import { useRequestLoading } from "./use-request-loading";
import { RequestLoadingView } from "./view-request-loading";

export function RequestLoading() {
  const vm = useRequestLoading();

  return <RequestLoadingView {...vm} />;
}

export type * from "./types-request-loading";
